<!-- views/admin/OfficialWebsiteConfig.vue -->
<template>
  <div class="website-config">
    <!-- 头部操作栏 -->
    <div class="header">
      <h1>官网配置管理</h1>
      <div class="header-actions">
        <button class="btn preview-btn" @click="previewWebsite">预览官网</button>
        <button class="btn save-btn" @click="saveConfig" :disabled="isSaving">
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>

    <!-- 配置编辑区域 -->
    <div class="config-editor">
      <!-- 基础信息配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>基础信息</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>网站标题</label>
            <input type="text" v-model="configData.data.base.title" placeholder="请输入网站标题">
          </div>
          <div class="form-group">
            <label>宣传标语</label>
            <input type="text" v-model="configData.data.base.slogan" placeholder="请输入宣传标语">
          </div>
          <div class="form-group">
            <label>Banner背景图</label>
            <div class="image-upload">
              <img v-if="configData.data.base.bannerBg" :src="configData.data.base.bannerBg" class="preview-img">
              <div v-else class="upload-placeholder">
                <span>点击上传图片</span>
              </div>
              <input type="file" @change="uploadBannerImage" accept="image/*" hidden ref="bannerUpload">
              <button class="upload-btn" @click="$refs.bannerUpload.click()">上传图片</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 主题配置（横向排列） -->
      <div class="config-section">
        <div class="section-header">
          <h2>主题配置</h2>
        </div>
        <div class="section-content theme-content">
          <div class="form-group theme-item">
            <label>主色调</label>
            <div class="color-picker">
              <input type="color" v-model="configData.data.theme.primaryColor">
              <span>{{ configData.data.theme.primaryColor }}</span>
            </div>
          </div>
          <div class="form-group theme-item">
            <label>辅色调</label>
            <div class="color-picker">
              <input type="color" v-model="configData.data.theme.secondaryColor">
              <span>{{ configData.data.theme.secondaryColor }}</span>
            </div>
          </div>
          <div class="form-group theme-item">
            <label>浅色背景</label>
            <div class="color-picker">
              <input type="color" v-model="configData.data.theme.lightBg">
              <span>{{ configData.data.theme.lightBg }}</span>
            </div>
          </div>
<!--          <div class="form-group theme-item">
            <label>字体色</label>
            <div class="color-picker">
              <input type="color" v-model="configData.data.theme.textColor">
              <span>{{ configData.data.theme.textColor }}</span>
            </div>
          </div>-->
        </div>
      </div>

      <!-- 页脚配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>页脚配置</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>联系方式</label>
            <input type="text" v-model="configData.data.footer.contact" placeholder="请输入联系方式">
          </div>
          <div class="form-group">
            <label>版权信息</label>
            <input type="text" v-model="configData.data.footer.copyright" placeholder="请输入版权信息">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import {getBanner, updateBannerApi, uploadFileApi} from '@/api/website'
//import { uploadImage } from '@/api/upload'

// 配置数据
const configData = ref({
    id: 1,
   data:{
     base: {
       title: '',
       slogan: '',
       bannerBg: ''
     },
     theme: {
       primaryColor: '#E6398B',
       secondaryColor: '#1890ff',
       lightBg: '#f9f9f9',
       textColor: '#333334'
     },
     footer: {
       contact: '',
       copyright: ''
     },
     orgData: {
       host: {
         name: '',
         contactPerson: '',
         phone: '',
         address: '',
         introText: '',
         introImages: [],
         introVideo: '',
         officialLink: ''
       },
       undertake: {
         name: '',
         contactPerson: '',
         phone: '',
         address: '',
         introText: '',
         introImages: [],
         introVideo: '',
         officialLink: ''
       }
     },
     sections:[],
   }
})

const isSaving = ref(false)

// 加载配置
const loadWebsiteConfig = async () => {
  try {

    const response = await getBanner({"adminId":1})
    if (response.data) {
      console.log('获取配置成功:', response.data.data)
      configData.value = {
        ...configData.value,
        ...response.data.data,
        theme: { ...configData.value.data.theme, ...response.data.data.data.theme }
      }
      console.log('configData.data.value:', configData.value)
    }
  } catch (error) {
    console.error('加载配置失败:', error)
    alert('加载配置失败，请重试')
  }
}

// 保存配置
const saveConfig = async () => {
  try {
    isSaving.value = true;  // 开始保存时设置加载状态

    if (!configData.value.data.base.title) {  // 使用 value 访问响应式数据
      alert('请填写网站标题')
      isSaving.value = false;  // 提前返回时也要重置状态
      return
    }
    await updateBannerApi(configData.value)

    alert('保存成功！')
  } catch (error) {
    console.error('保存配置失败:', error)
    alert('保存失败，请重试')
  } finally {
    isSaving.value = false
  }
}


// 预览官网
const previewWebsite = () => {
  window.open(window.location.origin, '_blank')
}

// 上传Banner图片
const uploadBannerImage = async (event) => {
  const file = event.target.files[0]
  console.log('file:', file)
  if (!file) return
  try {
    const formData = new FormData()
    formData.append('multipartFile', file)
    const response = await uploadFileApi(formData)
    console.log('response:', response.data.data)
    // 根据实际API响应结构调整
    if (response.data && response.data.data) {
      configData.value.data.base.bannerBg = response.data.data
    }
  } catch (error) {
    console.error('上传图片失败:', error)
    alert('上传失败，请重试')
  }
}

// 初始化加载配置
onMounted(() => {
  loadWebsiteConfig()
})
</script>

<style scoped lang="scss">
.website-config {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.header {
  background-color: white;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
  border-radius: 8px 8px 0 0; // 保持顶部圆角
  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .preview-btn {
    background-color: #1890ff;
    color: white;

    &:hover:not(:disabled) {
      background-color: #40a9ff;
    }
  }

  .save-btn {
    background-color: #E6398B;
    color: white;

    &:hover:not(:disabled) {
      background-color: #d4287a;
    }
  }
}

.config-editor {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.config-section {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  background-color: #fafafa;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  input[type="text"],
  input[type="color"],
  select,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
}

.color-picker {
  display: flex;
  align-items: center;
  gap: 12px;

  input[type="color"] {
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    cursor: pointer;
  }

  span {
    font-size: 14px;
    color: #666;
  }
}

.image-upload {
  display: flex;
  align-items: center;
  gap: 16px;

  .preview-img {
    width: 200px;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .upload-placeholder {
    width: 200px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ddd;
    border-radius: 4px;
    color: #999;
    font-size: 14px;
  }

  .upload-btn {
    padding: 8px 16px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: #e8e8e8;
    }
  }
}

/* 主题配置横向排列核心样式 */
.theme-content {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
}

.theme-item {
  flex: 1;
  min-width: 200px; /* 最小宽度，防止太窄 */
  margin-bottom: 0 !important; /* 取消纵向间距 */
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>